module.exports = __webpack_public_path__ + "static/media/kaplica_z4.16215e89.png";